import React, { useEffect } from 'react'
import {
  Box,
  CircularProgress,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'
//import { useStoreActions, useStoreState } from '../../store/store.hooks'
//import { useForm } from 'react-hook-form'

const useStyles = makeStyles((theme) => ({
  root: {
    // Ensures the box stretches to the height of the parent if needed
    // Otherwise, it will just fill the width by default
    // minHeight: '200px',
    display: 'flex',
    flexDirection: 'column', // Stack spinner and text vertically
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    padding: '1rem 0.5rem',
    borderRadius: '1rem',
    border: `1px solid #1e28642d`,
  },

  spinner: {
    color: '#1e28649d',
  },

  text: {
    marginTop: '1rem',
    color: '#1E2864',
    fontWeight: 700,
    fontSize: '0.8rem',
  },
}))

const LoadingState = ({ label, ...props }) => {
  const classes = useStyles()
  const { t } = useTranslation('loadingState')
  const defaultLabel = t('loading', 'One second...')

  return (
    <>
      <Box className={classes.root}>
        <CircularProgress
          title={label || defaultLabel}
          {...props}
          className={classes.spinner}
        />
        {label && (
          <Typography variant="body1" className={classes.text}>
            {label}
          </Typography>
        )}
      </Box>
    </>
  )
}

LoadingState.displayName = 'LoadingState'
export { LoadingState }
